module.exports = __webpack_public_path__ + "img/devoluciones.1c5d1ecd.svg";